// 관리자 페이지
import Analytics from '../views/manager/analystic.vue';
import NaverAds from '../views/manager/naverAds.vue';
import AutoMessage from '../views/manager/autoMessage.vue';
import QuickstarsOrder from '../views/manager/quickstarsOrder.vue';
import Settlement from '../views/manager/settlement.vue';

const managerRoutes = {
  children: [
    // 애널리틱스
    {
      path: 'analytics',
      name: 'Analytics',
      component: Analytics
    },

    // 네이버 광고대상 조회
    {
      path: 'naver-ads',
      name: 'NaverAds',
      component: NaverAds
    },

    // 자동 문자
    {
      path: 'auto-message',
      name: 'AutoMessage',
      component: AutoMessage
    },

    // 퀵스타 주문처리
    {
      path: 'quickstars-order',
      name: 'QuickstarsOrderManage',
      component: QuickstarsOrder
    },

    // 정산 관리
    {
      path: 'settlement',
      name: 'Settlement',
      component: Settlement
    },
  ]
};

export default managerRoutes;
